/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: sj
 * @LastEditTime: 2022-08-09 14:35:56
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, DatePicker, notification, Row } from 'antd'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { List } from '../../../models/page'
import { LimitPageParams } from '../../../services/insurance'
import { ThemeContext } from '../../../theme/ThemeContext'
import { selectInsuranceArray } from '../../tenant/setting/TenentSettingSlice'
import { LimitPriceColumns } from '../Columns'
import {
  catalogUpdateAnalysisAsync,
  getLimitPage,
  LimitPriceValue,
} from '../InsuranceSlice'
import { CurrentQuery } from '../province/CurrentQuery'
import styles from '../province/province.module.css'

export const CatalogeUpdate = () => {
  const dispatch = useDispatch<RootDispatch>()

  const dateFormat = 'YYYY/MM/DD';

  const [currentDate, setCurrentDate] = useState(moment(new Date(), dateFormat).format(dateFormat))

  const send = (date: string) => {
    dispatch(catalogUpdateAnalysisAsync(date)).then(unwrapResult).then(() => {
      notification.success({
        message: "分析成功"
      })
    })
  }
  return (
    <div className={styles.content}>
      <Row gutter={20}>
        <Col span={6}>

          <DatePicker
            onChange={(e) => {
              const date = moment(e).format(dateFormat)
              setCurrentDate(date)
              send(date)
            }}
            defaultValue={moment(new Date(), dateFormat)}
            format={dateFormat} style={{ width: '100%' }} />
        </Col>
        <Col >
          <Button type='primary' onClick={() => {
            send(currentDate)
          }}>分析</Button>
        </Col>
      </Row>
    </div>
  )
}
